<template>
  <admin-layout isLayout="ideas">
    <IdeaHeader
      isLayout="ideas"
      title="Taslak Proje Fikirlerim"
      :subTitle="subTitle"
    />
    <div
      v-if="getDraftProductData.length > 0"
      style="margin: 50px 15px"
      class="ideas-table-wrapper"
    >
      <vue-good-table
        class="admin-table"
        :columns="columns"
        :rows="getDraftProductData"
        :line-numbers="true"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'action'">
            <button
              class="btn-innovation-radius bg-blue-2 px-4 py-2"
              data-toggle="modal"
              data-target="#modal-idea-detail"
              @click.stop="tableEdit(props.row)"
            >
              Düzenle
            </button>
            <button
              class="btn-innovation-radius bg-red-1 px-4 py-2"
              data-toggle="modal"
              data-target="#modal-idea-detail"
              @click.stop="deleteCardShowModal(props.row)"
            >
              Sil
            </button>
          </div>
          <div v-else-if="props.column.field == 'CreatedOnUtc'">
            {{
              props.formattedRow[props.column.field] | newDateFormatterFilter
            }}
          </div>
          <div v-else>
            {{ props.formattedRow[props.column.field] }}
          </div></template
        >
      </vue-good-table>

      <div class="row mt-4 d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRecords"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <NotIdea v-else />
    <transition name="fade">
      <AutomotiveProduct
        :isDraft="true"
        v-if="isShareSuggestion"
        @close="isShareSuggestion = $event"
        :editPagedData="editData"
      />
    </transition>
    <transition name="fade">
      <CardDelete
        v-if="isCardDelete"
        @close="isCardDelete = $event"
        @delete="tableDelete"
        :isSuggestion="false"
      />
    </transition>
  </admin-layout>
</template>

<script>
import { mapGetters } from "vuex";

import { suggestionRdService, upload } from "../../services";
import { fileTypeCheck, newDateFormatter } from "../../helpers";

import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import IdeaHeader from "../../components/MyIdea/IdeaHeader.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import NotIdea from "../../components/MyIdea/NotIdea.vue";
import CardDelete from "../../components/Main/Cards/Modals/CardDelete.vue";
import AutomotiveProduct from "../../components/Modals/AutomotiveProduct.vue";
export default {
  name: "DraftProduct",
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      columns: [
        {
          label: "Fikir Tarihi",
          field: "SuggestionDate",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Proje Adı",
          field: "Title",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Değer Akımı",
          field: "ValueCurrentName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Statü",
          field: "SuggestionStatusName",
          sortable: false,
          thClass: "vgt-center-align",
        },
        {
          label: "",
          field: "action",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
      ],
      editData: null,
      isShareSuggestion: false,
      cardDeleteDataId: null,
      isCardDelete: false,
      subTitle:
        "Taslak olarak kaydettiğiniz tüm süreç iyileştirme proje fikirlerinizi burada listeyebilirsiniz.",
    };
  },
  components: {
    VueGoodTable,
    AdminLayout,
    NotIdea,
    AutomotiveProduct,
    CardDelete,
    IdeaHeader
  },
  filters: {
    newDateFormatterFilter(value) {
      return newDateFormatter(value);
    },
  },
  watch: {
    currentPage() {
      this.getProductData();
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
    getDraftProductData() {
      return this.$store.getters["draft/getDraftProductData"];
    },
    totalRecords() {
      return this.$store.getters["draft/getDraftProductTotalRecords"];
    },
  },
  async created() {
    this.getProductData();
  },
  methods: {
    async getProductData() {
      const body = {
        pageIndex: this.currentPage - 1,
        pageSize: this.perPage,
        suggestionStatuses: [11],
        createdUserId: this.user.Data.UserId,
        loginUserId: this.user.Data.UserId,
      };
      await this.$store.dispatch("draft/setDraftProductData", body);
    },
    async tableEdit(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      const tmpData = item;
      tmpData.DownloadFile = [];
      if (item.FileIds.length > 0) {
        item.FileIds.forEach(async (element) => {
          const res = await upload.fetchDownloadFile(element);
          tmpData.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
            fileType: fileTypeCheck(res.Data.Extension),
          });
        });
      }
      if (this.user.Data.ProjectDocumentId != null) {
        const res = await upload.fetchDownloadFile(
          this.user.Data.ProjectDocumentId
        );
        tmpData.ProjeDocument = {
          DownloadBinary: res.Data.DownloadBinary,
          Extension: res.Data.Extension,
          Filename: res.Data.Filename,
          Id: res.Data.Id,
          fileType: fileTypeCheck(res.Data.Extension),
        };
      }
      this.editData = tmpData;
      this.$store.dispatch("loading/setIsLoading", false);
      this.isShareSuggestion = true;
    },
    deleteCardShowModal(item) {
      this.cardDeleteDataId = item.Id;
      this.isCardDelete = true;
    },
    async tableDelete() {
      try {
        const res = await suggestionRdService.fetchDeleteSuggestionRD(
          this.cardDeleteDataId
        );
        if (res.Message == "Suggestion is deleted") {
          this.$toast.success("İşleminiz başarıyla tamamlandı.", {
            position: "top",
          });
          this.$store.dispatch("draft/deleteDraftProductData");
          const body = {
            pageIndex: 0,
            pageSize: 15,
            suggestionStatuses: [11],
            createdUserId: this.user.Data.UserId,
            loginUserId: this.user.Data.UserId,
          };
          this.$store.dispatch("draft/setDraftProductData", body);
        } else {
          this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
            position: "top",
          });
        }
      } catch (error) {
        this.$toast.error("İşleminiz sırasında bir hata oluştu.", {
          position: "top",
        });
      }
    },
  },
};
</script>